/**
 * Storage keys — sessionStorage/localStorage keys. Single source of truth.
 * @module constants/authStorage
 */

export const AUTH_TOKEN_KEY = "swissaligner:authToken";
export const AUTH_USER_KEY = "swissaligner:authUser";
export const AUTH_UNAUTHORIZED_EVENT = "swissaligner:auth:unauthorized";
export const CASE_MANAGEMENT_LAST_TAB_KEY = "caseManagementLastTab";
